import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../imageWithBasePath";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../../feature-module/router/all_routes";
import { setDataTheme } from "../../redux/themeSettingSlice";
import { useDispatch, useSelector } from "react-redux";
import {
    commonHeader,
    instAdminHeader,
    recruiterHeader,
    studentHeader,
} from "../data/json/header";
import { restoreRecruiter } from "../../redux/authSlice";
const Header = () => {
    const [scrolled, setScrolled] = useState(false);
    const [isMegaMenu, setIsMegaMenu] = useState(false);
    const [subOpen, setSubopen] = useState<any>("");
    const [subsidebar, setSubsidebar] = useState("");
    const [subsidebar2, setSubsidebar2] = useState("");
    const [basePath, setBasePath] = useState("");
    const dispatch = useDispatch();
    const location = useLocation();
    const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);
    const user = useSelector((state: any) => state.auth.user);
    const isAuthenticated = useSelector(
        (state: any) => state.auth.isAuthenticated
    );
    const backupStack = useSelector(
        (state: any) => state.auth.backupStack ?? []
    );
    const recruiterBackup = backupStack.length > 0 ? backupStack[backupStack.length - 1] : null;
    const navigate = useNavigate();

    let displayHeaders: any = commonHeader;
    if (isAuthenticated) {
        if (user?.role === "student") {
            displayHeaders = [...commonHeader, ...studentHeader];
        }
        if (user?.role === "inst_admin") {
            displayHeaders = [...commonHeader, ...instAdminHeader];
        }
        if (user?.role === "recruiter") {
            displayHeaders = [...commonHeader, ...recruiterHeader];
        }
        if (user?.role === "account_manager") {
            displayHeaders = [...commonHeader, ...recruiterHeader.map((item: any) => ({
                ...item,
                menu: (item.menu || []).filter((m: any) => m.menuValue !== "Account Managers"),
            }))];
        }
    }

    const onHandleMobileMenu = () => {
        const root = document.getElementsByTagName("html")[0];
        root.classList.add("menu-opened");
    };
    const onhandleCloseMenu = () => {
        const root = document.getElementsByTagName("html")[0];
        root.classList.remove("menu-opened");
    };

    const toggleSidebar = (title: any) => {
        localStorage.setItem("menuOpened", title);
        if (title === subOpen) {
            setSubopen("");
        } else {
            setSubopen(title);
        }
    };
    const toggleSubsidebar = (subitem: any) => {
        if (subitem === subsidebar) {
            setSubsidebar("");
        } else {
            setSubsidebar(subitem);
        }
    };
    const toggleSubsidebar2 = (subitem: any) => {
        if (subitem === subsidebar2) {
            setSubsidebar2("");
        } else {
            setSubsidebar2(subitem);
        }
    };
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        // Add event listener
        window.addEventListener("scroll", handleScroll);

        // Cleanup on unmount
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    useEffect(() => {
        document.documentElement.setAttribute("class", dataTheme);
    }, [dataTheme]);
    useEffect(() => {
        const path = location.pathname;
        const pathArray = path.split("/").filter(Boolean); // Removes empty strings from the split result
        setBasePath(pathArray[0]);
    }, [location.pathname]);

    const switchBackToRecruiter = () => {
        const returnTo = recruiterBackup?.returnTo || all_routes.recruiterStudents;
        dispatch(restoreRecruiter());
        navigate(returnTo);
    };

    return (
        <>
            {/* Header */}
            <header className={`header-three ${scrolled ? "fixed" : ""}`}>
                <div className="container">
                    <div className="header-nav">
                        <div className="navbar-header">
                            <Link
                                id="mobile_btn"
                                to="#"
                                onClick={() => onHandleMobileMenu()}
                            >
                                <span className="bar-icon">
                                    <i className="isax isax-menu"></i>
                                </span>
                            </Link>
                            <div className="navbar-logo">
                                <Link
                                    className="logo-white header-logo"
                                    to={all_routes.homesix}
                                >
                                    <ImageWithBasePath
                                        src="assets/img/logo-white.png"
                                        className="logo"
                                        alt="Logo"
                                        width={250}
                                        height={50}
                                    />
                                </Link>
                                <Link
                                    className="logo-dark header-logo"
                                    to={all_routes.homesix}
                                >
                                    <ImageWithBasePath
                                        src="assets/img/logo-white.png"
                                        className="logo"
                                        alt="Logo"
                                        width={250}
                                        height={50}
                                    />
                                </Link>
                            </div>
                        </div>
                        <div
                            className={`main-menu-wrapper ${isMegaMenu ? "active" : ""}`}
                        >
                            <div className="menu-header">
                                <Link
                                    to={all_routes.homesix}
                                    className="menu-logo"
                                >
                                    <ImageWithBasePath
                                        src="assets/img/logo-white.png"
                                        className="img-fluid"
                                        alt="Logo"
                                        width={250}
                                        height={50}
                                    />
                                </Link>
                                <Link
                                    id="menu_close"
                                    className="menu-close"
                                    to="#"
                                    onClick={() => onhandleCloseMenu()}
                                >
                                    <i className="fas fa-times" />
                                </Link>
                            </div>
                            <ul
                                className={`main-nav ${isMegaMenu ? "active" : ""}`}
                            >
                                {displayHeaders.map(
                                    (mainMenus: any, mainIndex: any) => (
                                        <React.Fragment key={mainIndex}>
                                            {mainMenus.separateRoute ? (
                                                <li
                                                    key={mainIndex}
                                                    className={`megamenu ${
                                                        location.pathname.includes(
                                                            "home"
                                                        )
                                                            ? "active"
                                                            : ""
                                                    }`} // Add class has-submenu if required
                                                    // onClick={() => toggleSidebar(mainMenus.title)}
                                                    // onMouseOver={() => setIsMegaMenu(true)} onMouseLeave={() => setIsMegaMenu(false)}
                                                >
                                                    <Link to={mainMenus.base}>
                                                        {mainMenus.title}
                                                        {mainMenus.menu && (
                                                            <i className="fas fa-chevron-down" />
                                                        )}
                                                    </Link>
                                                    <ul
                                                        className={`submenu mega-submenu ${subOpen === mainMenus.title ? "d-block" : ""}`}
                                                        onMouseOver={() =>
                                                            setIsMegaMenu(true)
                                                        }
                                                        onMouseLeave={() =>
                                                            setIsMegaMenu(false)
                                                        }
                                                    >
                                                        <li>
                                                            <div className="megamenu-wrapper">
                                                                <div className="row">
                                                                    {mainMenus.menu &&
                                                                        mainMenus.menu.map(
                                                                            (
                                                                                menu: any,
                                                                                idx: any
                                                                            ) => (
                                                                                <div
                                                                                    className="col-lg-2"
                                                                                    key={
                                                                                        idx
                                                                                    }
                                                                                >
                                                                                    <div
                                                                                        className={`single-demo ${location.pathname === menu.route ? "active" : ""}`}
                                                                                    >
                                                                                        <div className="demo-img">
                                                                                            <Link
                                                                                                to={
                                                                                                    menu.route
                                                                                                }
                                                                                                className="inner-demo-img"
                                                                                            >
                                                                                                <ImageWithBasePath
                                                                                                    src={
                                                                                                        menu.img
                                                                                                    }
                                                                                                    className="img-fluid "
                                                                                                    alt="img"
                                                                                                />
                                                                                            </Link>
                                                                                        </div>
                                                                                        <div className="demo-info">
                                                                                            <Link
                                                                                                to={
                                                                                                    menu.route
                                                                                                }
                                                                                                className="inner-demo-img"
                                                                                            >
                                                                                                {
                                                                                                    menu.menuValue
                                                                                                }
                                                                                            </Link>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        )}
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </li>
                                            ) : (
                                                <li
                                                    className={`has-submenu ${mainMenus?.menu?.some((item: any) => item?.route?.includes(location.pathname)) || basePath === mainMenus.base || basePath === mainMenus.base2 ? "active" : ""}`}
                                                >
                                                    <Link
                                                        to="#"
                                                        onClick={() =>
                                                            toggleSidebar(
                                                                mainMenus.title
                                                            )
                                                        }
                                                    >
                                                        {mainMenus.title}{" "}
                                                        <i
                                                            className={` ${basePath === "instructor" || basePath === "student" ? "isax isax-add" : "fas fa-chevron-down"}`}
                                                        ></i>
                                                    </Link>
                                                    <ul
                                                        className={`submenu ${subOpen === mainMenus.title ? "d-block" : ""}`}
                                                    >
                                                        {mainMenus.menu &&
                                                            mainMenus.menu?.map(
                                                                (
                                                                    menu: any,
                                                                    menuIndex: any
                                                                ) => (
                                                                    <React.Fragment
                                                                        key={`${mainIndex}-${menuIndex}`}
                                                                    >
                                                                        {menu.hasSubRoute ? (
                                                                            <li
                                                                                key={`${mainIndex}-${menuIndex}`}
                                                                                className={`${menu.hasSubRoute ? "has-submenu" : ""} ${menu?.subMenus?.some((item: any) => item?.route?.includes(location.pathname)) || basePath === menu.base ? "active" : ""}`}
                                                                            >
                                                                                <Link
                                                                                    to="#"
                                                                                    className={`hideonmob`}
                                                                                    onClick={() => {
                                                                                        toggleSubsidebar(
                                                                                            menu.menuValue
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        menu.menuValue
                                                                                    }
                                                                                </Link>
                                                                                <ul
                                                                                    className={`submenu showonmob ${subsidebar === menu.menuValue ? "d-block" : ""}`}
                                                                                >
                                                                                    {menu.subMenus?.map(
                                                                                        (
                                                                                            subMenu: any,
                                                                                            subMenuIndex: any
                                                                                        ) => (
                                                                                            <React.Fragment
                                                                                                key={`${mainIndex}-${menuIndex}-${subMenuIndex}`}
                                                                                            >
                                                                                                {subMenu.hasSubRoute ? (
                                                                                                    <li
                                                                                                        className={`${menu.hasSubRoute ? "has-submenu" : ""} ${subMenu?.subMenus?.some((item: any) => item?.route?.includes(location.pathname)) ? "active" : ""}`}
                                                                                                    >
                                                                                                        <Link
                                                                                                            to="#"
                                                                                                            onClick={() => {
                                                                                                                toggleSubsidebar2(
                                                                                                                    subMenu.menuValue
                                                                                                                );
                                                                                                            }}
                                                                                                        >
                                                                                                            {
                                                                                                                subMenu.menuValue
                                                                                                            }
                                                                                                        </Link>
                                                                                                        <ul
                                                                                                            className={`submenu ${subsidebar2 === subMenu.menuValue ? "d-block" : ""}`}
                                                                                                        >
                                                                                                            {subMenu.subMenus?.map(
                                                                                                                (
                                                                                                                    menu: any,
                                                                                                                    menuIndex2: any
                                                                                                                ) => (
                                                                                                                    <li
                                                                                                                        key={
                                                                                                                            menuIndex2
                                                                                                                        }
                                                                                                                        className={
                                                                                                                            location.pathname ===
                                                                                                                            menu.route
                                                                                                                                ? "active"
                                                                                                                                : ""
                                                                                                                        }
                                                                                                                    >
                                                                                                                        <Link
                                                                                                                            to={
                                                                                                                                menu.route
                                                                                                                            }
                                                                                                                        >
                                                                                                                            {
                                                                                                                                menu.menuValue
                                                                                                                            }
                                                                                                                        </Link>
                                                                                                                    </li>
                                                                                                                )
                                                                                                            )}
                                                                                                        </ul>
                                                                                                    </li>
                                                                                                ) : (
                                                                                                    <li
                                                                                                        className={
                                                                                                            location.pathname ===
                                                                                                            subMenu.route
                                                                                                                ? "active"
                                                                                                                : ""
                                                                                                        }
                                                                                                        key={`${mainIndex}-${menuIndex}-${subMenuIndex}`}
                                                                                                    >
                                                                                                        <Link
                                                                                                            to={
                                                                                                                subMenu.route
                                                                                                            }
                                                                                                        >
                                                                                                            {
                                                                                                                subMenu.menuValue
                                                                                                            }
                                                                                                        </Link>
                                                                                                    </li>
                                                                                                )}
                                                                                            </React.Fragment>
                                                                                        )
                                                                                    )}
                                                                                </ul>
                                                                            </li>
                                                                        ) : (
                                                                            <li
                                                                                key={`${mainIndex}-${menuIndex}`}
                                                                                className={
                                                                                    location.pathname.includes(
                                                                                        menu.route ||
                                                                                            ""
                                                                                    )
                                                                                        ? "active"
                                                                                        : ""
                                                                                }
                                                                            >
                                                                                <Link
                                                                                    to={
                                                                                        menu.route
                                                                                    }
                                                                                >
                                                                                    {
                                                                                        menu.menuValue
                                                                                    }
                                                                                </Link>
                                                                            </li>
                                                                        )}
                                                                    </React.Fragment>
                                                                )
                                                            )}
                                                    </ul>
                                                </li>
                                            )}
                                        </React.Fragment>
                                    )
                                )}
                            </ul>
                        </div>
                        <div className="header-btn d-flex align-items-center mt-3">
                            {!isAuthenticated && (
                                <>
                                    <div>
                                        <Link
                                            to={all_routes.login}
                                            className="btn btn-primary d-inline-flex align-items-center me-2 px-3"
                                        >
                                            Sign In
                                        </Link>
                                    </div>
                                    <Link
                                        to={all_routes.register}
                                        className="btn btn-secondary me-0 px-3"
                                    >
                                        Register
                                    </Link>
                                </>
                            )}
                            {recruiterBackup && (
                                <div className="btn btn-danger d-inline-flex align-items-center me-2 px-3" onClick={switchBackToRecruiter}>
                                    Switch Back
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </header>
            {/* /Header */}
        </>
    );
};

export default Header;
